var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeetingCommentsMarkAsQuestion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#59c778;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,6A6,6,0,1,1,6,0a6,6,0,0,1,6,6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.35,7.46a2.62,2.62,0,0,1,.06-.57,1.84,1.84,0,0,1,.19-.51A1.28,1.28,0,0,1,5.86,6a2,2,0,0,1,.31-.26,3.06,3.06,0,0,0,.39-.36A1.21,1.21,0,0,0,6.79,5a1.84,1.84,0,0,0,0-.41,1.09,1.09,0,0,0,0-.26.5.5,0,0,0-.1-.22.68.68,0,0,0-.31-.22A1.34,1.34,0,0,0,6,3.84a1.14,1.14,0,0,0-.33.05A.69.69,0,0,0,5.4,4a.58.58,0,0,0-.19.25.88.88,0,0,0-.06.33H4.07a2.08,2.08,0,0,1,.24-.79,1.49,1.49,0,0,1,.5-.58A1.71,1.71,0,0,1,5.35,3,2.15,2.15,0,0,1,6,2.88,2.8,2.8,0,0,1,6.84,3a1.54,1.54,0,0,1,.69.48,1.59,1.59,0,0,1,.3.5,2,2,0,0,1,.1.58,1.78,1.78,0,0,1-.19.8,3.43,3.43,0,0,1-.48.67L7,6.3l-.23.22a.87.87,0,0,0-.17.22.87.87,0,0,0-.14.33,2.12,2.12,0,0,0,0,.39Zm0,1.66V8H6.44V9.12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingCommentsMarkAsQuestion);
export default __webpack_public_path__ + "static/media/meeting-comments-mark-as-question.944dd90ebd04c3d98ef1597c94219b91.svg";
export { ForwardRef as ReactComponent };